import { useTranslation } from "react-i18next";
import { string, z } from "zod";
import { parseDecimal } from "../../../utils/decimalInput";

// Price/pdv are optional decimal strings (accepting "," like every other
// price field in the warehouse feature) - a zod-resolver form ignores
// per-field react-hook-form `rules`, so this is where they're validated
// instead of via decimalRules the way WarehouseItemForm does it.
function optionalDecimalField(t, { max } = {}) {
  return string()
    .optional()
    .refine(
      (value) => value === "" || value == null || !Number.isNaN(parseDecimal(value)),
      { message: t("InvalidDecimalNumber") },
    )
    .refine(
      (value) => {
        const parsed = parseDecimal(value);
        return parsed == null || parsed >= 0;
      },
      { message: t("MustBePositiveNumber") },
    )
    .refine(
      (value) => {
        if (max == null) return true;
        const parsed = parseDecimal(value);
        return parsed == null || parsed <= max;
      },
      { message: t("MustBeBetween0And100") },
    );
}

export function clinicServiceFormResolver(t) {
  return z.object({
    title: string()
      .min(1, { message: t("CantBeEmpty") })
      .max(50, { message: t("StringTooLong") }),
    description: string().max(70, { message: t("StringTooLong") }),
    price: optionalDecimalField(t),
    pdv: optionalDecimalField(t, { max: 100 }),
  });
}

export function useClinicServiceFormResolver() {
  const { t } = useTranslation();
  return z.object({
    title: string().min(1, { message: t("CantBeEmpty") }),
  });
}
